import React from 'react';

interface FilterToggleProps {
  isFiltersOpen: boolean;
  filtersCount: number;
  onToggle: () => void;
  showAsListButton?: boolean;
  onShowList?: () => void;
  hasFiltersApplied?: boolean;
  isListOpen?: boolean;
  hasResults?: boolean;
}

const FilterToggle: React.FC<FilterToggleProps> = ({ 
  isFiltersOpen, 
  filtersCount, 
  onToggle,
  showAsListButton = false,
  onShowList,
  hasFiltersApplied = false,
  isListOpen = false,
  hasResults = false
}) => {
  // El botón nunca debe estar deshabilitado si hay resultados disponibles para mostrar
  const isDisabled = false;
  
  const shouldShowAsListado = !isListOpen || isFiltersOpen; // Show Listado when not viewing results OR when in filters mode
  const shouldShowBadge = filtersCount > 0 && isListOpen && !isFiltersOpen; // Only show badge when viewing results (Filtros button), not in filters mode

  return (
    <button
      onClick={shouldShowAsListado ? onShowList : onToggle}
      disabled={isDisabled}
      className={[
        "relative flex items-center gap-2 px-3 py-2 shadow-xl rounded-xl transition-all",
        isDisabled 
          ? "text-gray-400 cursor-not-allowed bg-gray-100" 
          : "text-gray-600 hover:bg-gray-200 bg-white",
        // Removed conditional background for filters
      ].join(" ")}
    >
      <i className={`material-icons-outlined font-bold ${
        isDisabled ? "text-gray-400" : "text-primary"
      }`}>
        {shouldShowAsListado ? "list" : "tune"}
      </i>
      <span className="text-sm font-medium">
        {shouldShowAsListado ? "Listado" : "Filtros"}
      </span>
     
      {shouldShowBadge && (
        <div className="absolute top-0 right-0 transform translate-x-1/4 md:translate-x-1/2 -translate-y-1/4 bg-primary text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
          {filtersCount}
        </div>
      )}
    </button>
  );
};

export default FilterToggle;